import { Card, ContentBlock } from 'braid-design-system';
import type React from 'react';

import { GenericErrorSection } from './GenericErrorSection';

const ErrorSectionWithLayout: React.FC<
  React.PropsWithChildren<unknown>
> = () => (
  <Card>
    <ContentBlock>
      <GenericErrorSection />
    </ContentBlock>
  </Card>
);

export { ErrorSectionWithLayout };
